import { translate } from 'base/shared/Localization';

export const getReviewsSummaryHeaderText = (value) =>
  value === 1 ? translate('reviews.total_amount_one') : translate('reviews.total_amount_more');
